// Regression fixture for CC-26: a Kobalte Select whose options are backed by a
// LIVE query. PowerSync live queries re-emit a NEW array with NEW objects on
// every tick even when nothing changed; Kobalte rebuilds its collection from
// the new identities and `renderItem` re-runs for every node → the open
// listbox re-mounts its option DOM → the user's click lands on a stale node
// and the selection is silently dropped (value stays empty, submit disabled).
//
// This page simulates the live query with an interval that re-emits fresh
// identities (same content) every 50ms. NOT a product screen — registered
// ONLY in DEV (see router.ts) so `select-click.spec.ts` can assert the click
// persists. Guards the `reconcileById` identity-stabilization inside
// components/ui/select.tsx.
import { createRoute } from "@tanstack/solid-router";
import { createSignal, onCleanup } from "solid-js";

import { appRoute } from "./route";
import { Button } from "@/components/ui/button";
import { Select } from "@/components/ui/select";

const ROWS = [
  { value: "alpha", label: "Alpha" },
  { value: "beta", label: "Beta" },
  { value: "gamma", label: "Gamma" },
];

function Cc26ProbePage() {
  const [value, setValue] = createSignal("");
  // Simula la query live: cada tick re-emite array y objetos NUEVOS con el
  // MISMO contenido (exactamente lo que hace createPowerSyncQuery al re-emitir).
  const [tick, setTick] = createSignal(0);
  const interval = setInterval(() => setTick((t) => t + 1), 50);
  onCleanup(() => clearInterval(interval));

  const liveOptions = () => {
    tick(); // dependencia reactiva: fuerza re-emisión de identidad por tick
    return ROWS.map((row) => ({ ...row }));
  };

  return (
    <div class="p-8 space-y-4">
      <span data-testid="cc26-value">{value()}</span>
      <Select
        data-testid="cc26-select"
        aria-label="Probe live select"
        placeholder="Pick one"
        value={value()}
        onChange={(v) => setValue(v)}
        options={liveOptions()}
      />
      <Button data-testid="cc26-submit" disabled={!value()}>
        Create
      </Button>
    </div>
  );
}

export const cc26ProbeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/cc26-probe",
  component: Cc26ProbePage,
});
